/* eslint-disable require-atomic-updates */
import { Box, useTheme } from "@mui/material";
import {
  articleApi,
  buildArticleStructureData,
  commentsApi,
  getScheduleErrorText,
  useComment,
  useSlugValidation,
  useWorkflow,
} from "@platformx/authoring-apis";
import { RootState, previewContent } from "@platformx/authoring-state";
import {
  AUTH_INFO,
  CommonPlateformXDialog,
  Loader,
  MAPPING,
  ShowToastError,
  ShowToastSuccess,
  applyPublishStep,
  capitalizeFirstLetter,
  formatPageUrl,
  getBrandNameById,
  getCanonicalPageUrl,
  getCurrentLang,
  getSelectedBrandName,
  toAbsoluteUrl,
  runPublishSteps,
  seedSchedule,
  useUserSession,
  workflowKeys,
} from "@platformx/utilities";
import { WorkflowHistory } from "@platformx/workflow-management";
import { DamContentGallery } from "@platformx/x-image-render";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { CATEGORY_CONTENT, DRAFT } from "../../utils/Constants";
import { syncTagSm } from "../../utils/Helper";
import { resolveSlugDocType } from "../../utils/slugDocType";
import { useStyles } from "./CreateArticle.styles";
import {
  ArticleInitialState,
  articleInitialObj,
  handleTagOnChange,
  requestToSendArticle,
  resetImageSelected,
  updateImageData,
  validateDetails,
} from "./Utils/helperFunction";
import { planArticlePublish } from "./Utils/articlePublishPlan";
import { ArticleDetails } from "./components/ArticleDetails/ArticleDetails";
import PublishModal from "./components/PublishModal/PublishModal";
import TopBar from "./components/TopBar/TopBar";

export const CreateArticle = () => {
  const { currentContent } = useSelector((state: RootState) => state.content);
  const theme = useTheme();
  const classes = useStyles();
  const [onHover, setOnHover] = useState(false);
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState<any>({});
  const [tagData, setTagData] = useState<any>({});
  const [isFeatured, setIsFeatured] = useState(false);
  const [tagArr, setTagArr] = useState<any>(["Articles"]);
  const [tagCategory, setTagCategory] = useState<any>([]);

  const tagArrRef = useRef<{ tags: string[]; tag_sm: string[] }>({
    tags: ["Articles"],
    tag_sm: [],
  });
  const [socialOgTags, setSocialOgTags] = useState({ tagsSocialShare: ["Articles"] });
  const [articleInstance, setArticleInstance] = useState<any>(ArticleInitialState);
  const [getSession] = useUserSession();
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [checkDesc, setCheckDesc] = useState("");
  const compareInstance = useRef({});
  const { t, i18n } = useTranslation();
  const [previewButton, setPreviewButton] = useState(true);
  const [previewTooltip, setPreviewTooltip] = useState(true);
  const { userInfo, role } = getSession();
  const params = useParams();
  const slugValidation = useSlugValidation(resolveSlugDocType("article"));
  const articlePageUrl = new URL(window.location.href);
  const [galleryState, setGalleryState] = useState<boolean>(false);
  const galleryType = useRef<string>("Images");
  const [operationType, setOperationType] = useState<string>("");
  const [isClickedPublish, setIsClickedPublish] = useState(false);
  const unsavedChanges = useRef<boolean>(false);
  const [timerState, setTimerState] = useState(
    localStorage.getItem("articleTimerState") ? true : false,
  );
  const [lastmodifiedDate, setLastmodifiedDate] = useState(new Date().toISOString());
  const [key, setKey] = useState("");
  const navigate = useNavigate();
  const pathRef = useRef();
  const originalSlugRef = useRef<string>("");
  // The canonical the document was loaded with: shown as-is and re-sent as-is until the slug changes.
  const storedCanonicalRef = useRef<{ path: string; slug: string } | null>(null);
  const currentArticleData = useRef(
    articlePageUrl.searchParams.get("path")
      ? (articlePageUrl.searchParams.get("path") as string)
      : "",
  );
  // The article's real publish instant, for the JSON-LD `datePublished` builder
  // only. Kept OUT of articleInstance.CommonFields on purpose: that object is
  // spread verbatim into the save mutation (requestToSendArticle), and the
  // backend's input type does not accept `lastPublishedDate` as an input field
  // — it is an output-only field on the read query. Putting it in state made
  // every save fail with BAD_USER_INPUT (KIWI-6280 hotfix, kiwi 2026-09-10).
  const lastPublishedDateRef = useRef<string>("");

  const username = `${userInfo.first_name} ${userInfo.last_name}`;
  const login_user_id = userInfo?.user_id;
  const [isDraft, setIsDraft] = useState<boolean>(true);
  const dispatch = useDispatch();
  const [selectedImage, setSelectedImage] = useState({
    Thumbnail: "",
    Title: "",
    Description: "",
    bitStreamId: "",
  });
  const [workflow, setWorkflow] = useState({});
  const { getWorkflowDetails, workflowRequest } = useWorkflow();
  const [enableWorkflowHistory, setEnableWorkflowHistory] = useState<boolean>(false);
  const { comments } = useComment();
  const [isReload, setIsReload] = useState(false);

  const toggleGallery = (toggleState, type, keyName) => {
    setGalleryState(toggleState);
    if (type === "cancel") setOperationType(type);
    keyName !== "social_img" && isClickedPublish && handleClickOpen();
  };

  const showGallery = (gType, keyName = "") => {
    window.scrollTo(0, 0);
    galleryType.current = gType;
    setGalleryState(true);
    setKey(keyName);
  };

  const onUploadClick = (type, action) => {
    showGallery(type);
    setOperationType(action);
  };

  useEffect(() => {
    if (Object.keys(articleInstance).length === 0 && !params.id) {
      const newArticle = articleInitialObj(username);
      setArticleInstance(newArticle);
      compareInstance.current = newArticle;
    }
    const fetchWorkflowDetails = async () => {
      setIsLoading(true);
      if (currentArticleData.current === "" && !Object.keys(currentContent).length) {
        await getWorkflowDetails(
          role,
          login_user_id,
          setWorkflow,
          capitalizeFirstLetter("article"),
        );
      }
      setIsLoading(false);
    };
    fetchWorkflowDetails();
  }, []);
  const handleClickOpen = () => {
    setOpen(!open);
    setIsClickedPublish(!isClickedPublish);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const getTags = async () => {
    try {
      const res: any = await articleApi.getTags({
        start: 0,
        rows: 1000,
      });
      if (res?.authoring_getTagsList) {
        setTagData(res?.authoring_getTagsList);
      }
    } catch (err: any) {
      // console.log(JSON.stringify(err, null, 2));
    }
  };

  const handleTags = (event, category = "") => {
    handleTagOnChange(
      event,
      tagArr,
      setTagArr,
      tagArrRef,
      socialOgTags,
      setSocialOgTags,
      category,
      tagCategory,
      setTagCategory,
    );
  };

  useEffect(() => {
    if (slugValidation.isSubmitCheck) return;
    if (slugValidation.status === "unique") {
      ShowToastSuccess(t("slug_available", { docType: "Article" }));
    } else if (slugValidation.status === "not_unique") {
      ShowToastError(t("slug_not_unique", { docType: "Article" }));
    }
  }, [slugValidation.status, slugValidation.isSubmitCheck]);

  const handleSlugChange = (event) => {
    const { value } = event.target;
    setArticleInstance((prev) => ({
      ...prev,
      CommonFields: { ...prev.CommonFields, slug: value },
    }));
    slugValidation.invalidate();
  };

  const handleSlugBlur = () => {
    slugValidation.validate(articleInstance?.CommonFields?.slug, {
      excludeValue: originalSlugRef.current,
    });
  };

  const currentSlug = articleInstance?.CommonFields?.slug || "";
  const slugField = {
    value: currentSlug,
    onChange: handleSlugChange,
    onBlur: handleSlugBlur,
    // The stored canonical is the source of truth: shown as-is until the slug changes, then
    // rebuilt from the document's own primary brand.
    canonicalUrl:
      storedCanonicalRef.current?.path && storedCanonicalRef.current.slug === currentSlug
        ? toAbsoluteUrl(storedCanonicalRef.current.path)
        : getCanonicalPageUrl(
            currentSlug,
            i18n.language,
            "article",
            getBrandNameById(articleInstance?.CommonFields?.brand_name || ""),
          ),
    // Lets the Settings dialog's Cancel clear a validation status that no longer matches the slug.
    invalidate: slugValidation.invalidate,
  };

  // Single source of truth for "is the slug allowed to be saved" — called once
  // from every top-level Save/Publish entry point (onSave/onPublish), BEFORE
  // branching into create vs update. Checking only inside the update branch
  // left the create branch unchecked; once a document is created in this
  // session, isDraft flips to false and every later save takes the update
  // branch even without a page reload, so an empty/unverified slug could
  // still reach it. Enforcing here, ahead of that branch, guarantees the
  // slug is always valid by the time either branch runs.
  const guardSlugThenProceed = async (): Promise<boolean> => {
    if (!currentSlug) {
      ShowToastError(t("slug_required"));
      return false;
    }
    const isUnique = await slugValidation.checkNow(currentSlug, {
      excludeValue: originalSlugRef.current,
    });
    if (!isUnique) {
      ShowToastError(t("slug_url_not_unique", { docType: "Article" }));
      return false;
    }
    // Advance the baseline now so a later save/publish in this same
    // session (e.g. Publish right after Save as Draft) excludes against
    // the value the document now actually owns, instead of re-checking
    // it against itself and failing as "not unique".
    // eslint-disable-next-line require-atomic-updates
    originalSlugRef.current = currentSlug;
    return true;
  };

  const requestToSend = (pageState, pageUrl, IsDuplicate) => {
    const createArticleRequest = requestToSendArticle(
      pageState,
      pageUrl,
      IsDuplicate,
      articleInstance,
      tagArrRef,
      socialOgTags,
      updateStructureDataArticle,
      username,
      isFeatured,
      tagCategory,
      i18n.language,
      storedCanonicalRef.current,
    );
    return createArticleRequest;
  };
  //create comment
  const createComment = () => {
    const currentLanguage = getCurrentLang();
    const createCommentRequest = {
      document_path: `/content/documents/hclplatformx/${currentLanguage}/article/${currentArticleData.current}`,
      status: false,
      document_type: "Article",
      created_by: username, //articleInstance.CommonFields.createdBy,
      last_modified_by: username,
      reviewer_comments: [comments],
    };

    return commentsApi.createOrUpdateComment({
      input: createCommentRequest,
    });
  };
  const createArticle = (pageState, pageUrl, IsDuplicate = false) => {
    const createArticleRequest = requestToSend(pageState, pageUrl, IsDuplicate);
    return articleApi.createArticle({
      contentType: "Article",
      input: createArticleRequest,
    });
  };
  const updateArticle = (pageState, pageUrl, IsDuplicate = false) => {
    const updateArticleRequest = requestToSend(pageState, pageUrl, IsDuplicate);
    return articleApi.updateArticle({
      contentType: "Article",
      input: updateArticleRequest,
    });
  };
  const publishArticle = (pageUrl, step?: any) => {
    // With no step the request is exactly what it always was: just the page.
    const publishedRequest = step ? applyPublishStep({ page: pageUrl }, step) : { page: pageUrl };
    return articleApi.publishArticle({
      contentType: "Article",
      input: publishedRequest,
    });
  };
  const articleDetails = () => {
    return articleApi.fetchArticleDetails({
      contentType: "Article",
      path: currentArticleData.current,
    });
  };
  const getArticleData = async () => {
    setIsLoading(true);
    try {
      const detailsRes: any = await articleDetails();
      setIsLoading(false);
      if (detailsRes?.authoring_getCmsContentByPath !== null) {
        const articleObj = detailsRes?.authoring_getCmsContentByPath;
        const {
          title,
          short_description,
          description,
          banner,
          published_images,
          original_image,
          tags,
          tag_sm,
          settingsProperties,
          sub_title,
          structure_data,
          createdBy,
          lastModifiedBy,
          seo_enable,
          show_author,
          analytics_enable,
          path,
          workflow_status,
          stages,
          tag_name,
          last_modifiedBy,
          page,
          task_status,
          user_id,
          user_name,
          is_featured,
          modificationDate,
          creationDate,
          lastPublishedDate,
          notification,
          notification_title,
          notification_desc,
          notification_channel,
          notification_topics,
          notification_image,
          content_behind_rendering,
          slug,
          responseBrandname,
          secondary_brandname,
          brand_name,
        } = articleObj;
        setIsFeatured(is_featured);
        originalSlugRef.current = slug || "";
        storedCanonicalRef.current = articleObj.canonical_url
          ? { path: articleObj.canonical_url, slug: slug || "" }
          : null;
        lastPublishedDateRef.current = lastPublishedDate || "";
        const instance = {
          ...articleInstance,
          CommonFields: {
            ...articleInstance.CommonFields,
            // The document's own primary brand (read as responseBrandname); kept so saves and the
            // canonical URL follow it rather than the dropdown brand.
            brand_name: responseBrandname || brand_name || articleInstance.CommonFields?.brand_name,
            // Carried so an edit does not wipe the shared brands (the update replaces the document).
            ...(Array.isArray(secondary_brandname) ? { secondary_brandname } : {}),

            title,
            short_description: short_description || "",
            description,
            tags,
            tag_sm,
            // Seeded with the schedules the article already has, so the Schedule tab shows them
            // locked (KIWI-6762).
            settings: seedSchedule(settingsProperties, articleObj),
            structure_data: structure_data,
            createdBy,
            seo_enable,
            analytics_enable,
            lastModifiedBy,
            modificationDate,
            // creationDate must survive the round-trip so the save path stops
            // re-stamping it (KIWI-6280). lastPublishedDate does NOT belong
            // here — see lastPublishedDateRef above.
            creationDate,
            notification,
            notification_title: notification_title || title,
            notification_desc: notification_desc,
            notification_channel,
            notification_topics,
            notification_image: notification_image || "",
            content_behind_rendering,
            slug,
          },
          ObjectFields: {
            ...articleInstance.ObjectFields,
            banner,
            published_images,
            original_image,
            sub_title,
            show_author,
          },
        };
        setWorkflow({
          title,
          description,
          path,
          workflow_status,
          stages,
          tag_name,
          last_modifiedBy,
          createdBy,
          role,
          page,
          enable: stages?.length > 0 ? true : false,
          login_user_id,
          task_status,
          task_user_id: user_id,
          task_user_name: user_name,
        });
        setArticleInstance({ ...instance });

        compareInstance.current = { ...instance };
        setSocialOgTags({
          ...socialOgTags,
          tagsSocialShare: settingsProperties.keywords,
        });
        setContent({
          ...content,
          Url: banner,
          Title: sub_title,
          bitStreamId: original_image.bitStreamId,
        });
        setCheckDesc(description);
        tagArrRef.current = {
          ...tagArrRef.current,
          tags: tags,
          tag_sm: tag_sm,
        };
        setTagArr(tags);
        setTagCategory(tag_sm);
      }
    } catch (err: any) {
      const statusCode = err?.networkError?.statusCode || 0;

      setIsLoading(false);
      ShowToastError(t("api_error_toast"), statusCode);
    }
  };

  useEffect(() => {
    setIsReload(!isReload);
    getTags();
    if (timerState) {
      localStorage.setItem("articleTimerState", "true");
    }
  }, [comments, timerState]);

  useEffect(() => {
    if (Object.keys(currentContent)?.length > 0) {
      const {
        title,
        short_description,
        description,
        banner,
        published_images,
        original_image,
        tags,
        settings,
        sub_title,
        structure_data,
        createdBy,
        article_settings,
        seo_enable,
        show_author,
        analytics_enable,
        creationDate,
        modificationDate,
        lastPublishedDate,
        notification,
        notification_title,
        notification_desc,
        notification_channel,
        notification_topics,
        notification_image,
        content_behind_rendering,
        slug,
      } = currentContent;
      setCheckDesc(description);
      originalSlugRef.current = slug || "";
      lastPublishedDateRef.current = lastPublishedDate || "";
      const instance = {
        ...articleInstance,
        CommonFields: {
          ...articleInstance.CommonFields,
          title,
          short_description: short_description || "",
          description,
          tags,
          settings,
          structure_data,
          createdBy,
          seo_enable,
          analytics_enable,
          creationDate,
          modificationDate,
          notification,
          notification_title: notification_title || title,
          notification_desc: notification_desc,
          notification_channel,
          notification_topics,
          notification_image: notification_image || "",
          content_behind_rendering,
          slug,
        },
        ObjectFields: {
          ...articleInstance.ObjectFields,
          banner,
          published_images,
          original_image,
          sub_title,
          show_author,
        },
      };
      setArticleInstance({ ...instance });

      compareInstance.current = { ...instance };
      setSocialOgTags({
        ...socialOgTags,
        tagsSocialShare: article_settings.keywords,
      });
      setContent({
        ...content,
        Url: banner, //original_image.Thumbnail,
        Title: sub_title,
        bitStreamId: original_image.bitStreamId,
      });

      tagArrRef.current = {
        ...tagArrRef.current,
        tags: tags,
      };
      setTagArr(tags);
      setIsDraft(currentContent?.isDraft);
      pathRef.current = currentContent?.pageName;
      setWorkflow(currentContent?.workflow);
    } else if (currentArticleData.current) {
      getArticleData();
    }
  }, []);
  const validateArticleDetails = (isPublish = false) => {
    return validateDetails(articleInstance, tagArrRef, isPublish);
  };
  const navigateTo = () => {
    unsavedChanges.current = false;
    navigate("/content/article");
  };

  const [dialogContent, setDialogContent] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
    confirmButtonText: "",
    closeButtonText: "",
    modal: "",
  });
  const handleCloseModal = () => {
    setDialogContent({ ...dialogContent, isOpen: false });
  };
  const enableDialog = (type = "", publishedMessage = "") => {
    const contentTosend = {
      ...dialogContent,
      isOpen: true,
      title: t("congratulations"),
      subTitle:
        type === workflowKeys.approve
          ? `${t("your")} ${t("article")} ${publishedMessage || t("publish_popup_message")}`
          : t("requested_action"),
      confirmButtonText: t("go_to_listing"),
      modal: "publish",
    };
    setDialogContent(contentTosend);
  };
  const exitWarnDialog = () => {
    const contentTosend = {
      isOpen: true,
      title: t("save_warn_title"),
      subTitle: t("save_warn_subtitle"),
      closeButtonText: t("stay_here"),
      confirmButtonText: t("take_me_out"),
      modal: "warning",
    };
    setDialogContent(contentTosend);
  };

  const onSave = async (isWorkflow = true, props = {}, event_step = "") => {
    // if (!validateArticleDetails()) {
    setIsLoading(true);
    setOpen(false);
    try {
      const articleCommonFields = articleInstance?.CommonFields || {};
      const { title } = articleCommonFields;
      const pageURL =
        !isDraft || currentArticleData.current
          ? pathRef.current || currentArticleData.current
          : title.replace(/[^A-Z0-9]+/gi, "-").toLowerCase();

      if (!(await guardSlugThenProceed())) {
        setIsLoading(false);
        return;
      }

      if (currentArticleData.current || !isDraft) {
        const detailsRes: any = await updateArticle(DRAFT, pageURL);
        if (detailsRes.authoring_updateContent.message === "Successfully updated!!!") {
          if (!isWorkflow) {
            ShowToastSuccess(`${t("article")} ${t("updated_toast")}`);
            if (currentArticleData.current) {
              getArticleData();
            }
          } else {
            const { workflow_status, success } = await workflowRequest(props, event_step);
            if (success) {
              workflow_status === workflowKeys.publish.toLowerCase() &&
              event_step === workflowKeys.approve
                ? enableDialog(workflowKeys.approve)
                : enableDialog();
            }
          }
          pathRef.current = detailsRes.authoring_updateContent?.path.substring(
            detailsRes.authoring_updateContent?.path.lastIndexOf("/") + 1,
          );
          setIsLoading(false);
          setTimerState(true);

          setLastmodifiedDate(new Date().toISOString());
          compareInstance.current = articleInstance;
          unsavedChanges.current = false;
        } else {
          ShowToastSuccess(detailsRes.authoring_updateContent.message);
        }
      } else {
        const detailsRes: any = await createArticle(DRAFT, pageURL);
        if (detailsRes.authoring_createContent.message === "Successfully created!!!") {
          if (!isWorkflow) {
            ShowToastSuccess(`${t("article")} ${t("saved_toast")}`);
          }
          setIsDraft(false);
          setTimerState(true);
          setLastmodifiedDate(new Date().toISOString());
          pathRef.current = detailsRes.authoring_createContent?.path.substring(
            detailsRes.authoring_createContent?.path.lastIndexOf("/") + 1,
          );
          const { title: title1 = "", description } = articleInstance.CommonFields;

          const workflowObj = {
            createdBy: username,
            description,
            title: title1,
            path: detailsRes.authoring_createContent?.path,
            workflow_status: workflowKeys.draft,
            tag_name: "Article",
            last_modifiedBy: username,
          };
          if (isWorkflow) {
            const { success } = await workflowRequest(workflowObj, workflowKeys.approve);
            if (success) {
              enableDialog();
            }
          }
          setWorkflow({ ...workflow, ...workflowObj });
          setIsLoading(false);
          compareInstance.current = articleInstance;
          unsavedChanges.current = false;
        } else {
          ShowToastSuccess(detailsRes.authoring_createContent.message);
        }
      }
    } catch (err: any) {
      const statusCode = err?.networkError?.statusCode || 0;
      setIsLoading(false);
      setTimerState(false);
      setLastmodifiedDate("");
      ShowToastError(t("api_error_toast"), statusCode);
    } finally {
      setIsLoading(false);
    }
    // }
  };
  const onPublish = async () => {
    if (!validateArticleDetails(true)) {
      // Decide everything about the schedule BEFORE anything is saved, so a bad time never leaves a
      // half-done publish behind.
      const plan = planArticlePublish(articleInstance);
      if (!plan.verdict.valid) {
        ShowToastError(capitalizeFirstLetter(t(plan.verdict.messageKey)));
        return;
      }
      try {
        setIsLoading(true);
        setOpen(false);
        const articleCommonFields = articleInstance?.CommonFields || {};
        const { title } = articleCommonFields;
        const pageURL =
          currentArticleData.current || !isDraft
            ? currentArticleData.current || pathRef.current
            : title.replace(/[^A-Z0-9]+/gi, "-").toLowerCase();
        if (!(await guardSlugThenProceed())) {
          setIsLoading(false);
          return;
        }
        // A scheduled publish must not be saved as PUBLISHED (see planArticlePublish).
        const detailsRes: any =
          currentArticleData.current || !isDraft
            ? await updateArticle(plan.saveState, pageURL)
            : await createArticle(plan.saveState, pageURL);
        const updatedPagePath =
          currentArticleData.current || !isDraft
            ? detailsRes.authoring_updateContent.path
            : detailsRes.authoring_createContent.path;
        if (
          currentArticleData.current || !isDraft
            ? detailsRes.authoring_updateContent.message === "Successfully updated!!!"
            : detailsRes.authoring_createContent.message === "Successfully created!!!"
        ) {
          try {
            const publishedPage = updatedPagePath.substring(updatedPagePath.lastIndexOf("/") + 1);
            if (plan.isScheduled) {
              // Each step is its own call to the publish mutation, run in order; any failure
              // rejects, so a schedule that did not take effect never looks like a success.
              await runPublishSteps(plan.steps, (step) => publishArticle(publishedPage, step));
              enableDialog(
                workflowKeys.approve,
                plan.confirmation ? t(plan.confirmation.key, plan.confirmation.params) : "",
              );
              setIsLoading(false);
              setTimerState(true);
              setLastmodifiedDate(new Date().toISOString());
            } else {
              //call Publish api for article
              const response: any = await publishArticle(publishedPage);
              if (response.authoring_publishContent.message === "Article published successfully") {
                enableDialog(workflowKeys.approve);
                setIsLoading(false);
                setTimerState(true);
                setLastmodifiedDate(new Date().toISOString());
              } else {
                ShowToastSuccess(response.authoring_publishContent.message);
              }
            }
          } catch (err: any) {
            setTimerState(false);
            setLastmodifiedDate("");
            const statusCode = err?.networkError?.statusCode || 0;

            ShowToastError(
              err?.name === "SchedulePartialFailureError"
                ? // The first schedule is already in place; say so, or the editor resubmits straight
                  // into "already trigger is initiated".
                  `${t("schedule_partial_failure")} ${getScheduleErrorText(err.cause, t)}`
                : getScheduleErrorText(err, t),
              statusCode,
            );
          }
        } else {
          ShowToastSuccess(
            currentArticleData.current
              ? detailsRes.authoring_updateContent.message
              : detailsRes.authoring_createContent.message,
          );
        }
      } catch (err: any) {
        const statusCode = err?.networkError?.statusCode || 0;
        ShowToastError(
          err.graphQLErrors.length > 0 ? err.graphQLErrors[0].message : t("api_error_toast"),
          statusCode,
        );
      } finally {
        setIsLoading(false);
      }
    }
  };
  const resetSelectedImage = () => {
    resetImageSelected(setContent, setSelectedImage);
  };
  const updateImageField = (obj) => {
    updateImageData(obj, content, setArticleInstance, articleInstance);
  };
  const handelPreview = () => {
    const { title, modificationDate } = articleInstance.CommonFields;
    const pageUrl = currentArticleData.current
      ? currentArticleData.current
      : title.replace(/[^A-Z0-9]+/gi, "-").toLowerCase();
    const article_settings = {
      socialog_url: `${AUTH_INFO.publishUri + "en"}/article/${pageUrl}`,
      keywords: socialOgTags.tagsSocialShare,
    };
    const current_page_url = `/${pageUrl}`;
    const banner = content?.Url;
    const sub_title = content?.Title;
    const { tags } = tagArrRef.current;
    const articlePreview = {
      ...articleInstance.CommonFields,
      ...articleInstance.ObjectFields,
      // title,
      // description,
      tags,
      page_lastmodifiedby: username,
      developed_date: modificationDate || new Date().toISOString(),
      banner,
      current_page_url,
      article_settings,
      sub_title,
      contentType: "Article",
      isDraft: isDraft,
      pageName: pathRef.current,
      workflow: workflow,
    };
    dispatch(previewContent(articlePreview));
    navigate("/content/preview", {
      state: {
        contentType: MAPPING.Article,
        pageName: pathRef.current || currentArticleData.current,
      },
    });
  };
  const updateStructureDataArticle = () => {
    const contentData = {
      ...(articleInstance?.CommonFields || {}),
      // Merged in for the builder only — see lastPublishedDateRef above for why
      // this must never live in articleInstance.CommonFields itself.
      lastPublishedDate: lastPublishedDateRef.current,
    };
    const { title, slug } = contentData;
    // Slug-first so the JSON-LD url matches the canonical delivery route the
    // slug field advertises; the doc path is the pre-slug fallback.
    const pageURL =
      slug ||
      (currentArticleData.current
        ? currentArticleData.current
        : title?.replace(/[^A-Z0-9]+/gi, "-").toLowerCase());
    const articleObjectFields = articleInstance?.ObjectFields || {};
    const tags = JSON.parse(JSON.stringify(tagArrRef.current));
    const selectedBrandRoute = formatPageUrl(
      getBrandNameById(articleInstance?.CommonFields?.brand_name || "") ||
        getSelectedBrandName() ||
        i18n.language,
    );
    return buildArticleStructureData({
      content: contentData,
      originalImage: articleObjectFields?.original_image,
      keywords: tags.tags,
      pageUrl: pageURL,
      selectedBrandRoute,
    });
  };

  useEffect(() => {
    if (JSON.stringify(articleInstance) === JSON.stringify(compareInstance.current)) {
      unsavedChanges.current = false;
    } else {
      unsavedChanges.current = true;
    }
    const { title } = articleInstance?.CommonFields || {};
    const { banner } = articleInstance?.ObjectFields || {};

    if (title === "" || banner === "" || checkDesc === "") {
      setPreviewButton(true);
    } else {
      if (!currentArticleData.current && isDraft) {
        setPreviewTooltip(false);
      } else {
        setPreviewButton(false);
      }
    }
  }, [articleInstance, checkDesc, isDraft]);

  const returnBack = () => {
    if (unsavedChanges.current) {
      exitWarnDialog();
    } else {
      navigate("/content/article");
    }
  };

  const handleSelectedImage = (image, keyName) => {
    if (keyName === "social_img") {
      setShow(true);
      setArticleInstance({
        ...articleInstance,
        CommonFields: {
          ...articleInstance.CommonFields,
          notification_image: image?.Thumbnail,
          settings: {
            ...articleInstance.CommonFields.settings,
            socialog_image: image?.Thumbnail,
          },
        },
      });
    } else {
      setSelectedImage(image);
      setContent({
        Url: image.Thumbnail,
        Title: image.Title,
        Description: image.Description,
        bitStreamId: image.bitStreamId,
      });
      setArticleInstance({
        ...articleInstance,
        ObjectFields: {
          ...articleInstance.ObjectFields,
          original_image: image,
          banner: image.bitStreamId,
          published_images: [],
        },
      });
    }
    setGalleryState(false);
  };
  useEffect(() => {
    return syncTagSm(tagCategory, tagData, tagArr, (nextTagCategory) => {
      setTagCategory(nextTagCategory);
      tagArrRef.current = {
        ...tagArrRef.current,
        tag_sm: nextTagCategory,
      };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tagData, tagArr]);
  return (
    <Box
      className={classes.containerStyle}
      onClick={() => setOnHover(false)}
      data-testid='article-hover'
      sx={{
        overflowY: galleryState ? "hidden" : "scroll",
      }}>
      {isLoading && <Loader />}
      <Box
        sx={{
          backgroundColor: theme.palette.customColor.BGLIGHT,
        }}>
        {galleryState && (
          <DamContentGallery
            handleImageSelected={handleSelectedImage}
            toggleGallery={toggleGallery}
            assetType={galleryType.current === "Images" ? "Image" : "Video"}
            keyName={key}
            isCrop={false}
            dialogOpen={galleryState}
          />
        )}
      </Box>
      <TopBar
        returnBack={returnBack}
        handleClickOpen={handleClickOpen}
        onSave={onSave}
        handelPreview={handelPreview}
        state={articleInstance}
        setState={setArticleInstance}
        socialOgTags={socialOgTags}
        setSocialOgTags={setSocialOgTags}
        show={show}
        setShow={setShow}
        updateStructureDataArticle={updateStructureDataArticle}
        previewButton={previewButton}
        toolTipText={previewTooltip ? t("preview_tooltip") : t("preview_tooltip1")}
        category={CATEGORY_CONTENT}
        subCategory={"article"}
        workflow={workflow}
        timerState={timerState}
        lastmodifiedDate={lastmodifiedDate}
        setEnableWorkflowHistory={setEnableWorkflowHistory}
        setIsFeatured={setIsFeatured}
        isFeatured={isFeatured}
        slugField={slugField}
      />
      {enableWorkflowHistory ? (
        <WorkflowHistory workflow={workflow} setEnableWorkflowHistory={setEnableWorkflowHistory} />
      ) : (
        <ArticleDetails
          returnBack={returnBack}
          onHover={onHover}
          setOnHover={setOnHover}
          content={content}
          setContent={setContent}
          state={articleInstance}
          setState={setArticleInstance}
          setSelectedImage={setSelectedImage}
          selectedImage={selectedImage}
          onUploadClick={onUploadClick}
          operationType={operationType}
          resetSelectedImage={resetSelectedImage}
          updateImageField={updateImageField}
          setIsClickedPublish={setIsClickedPublish}
          setCheckDesc={setCheckDesc}
          workflow={workflow}
        />
      )}
      <PublishModal
        open={open}
        handleClose={handleClose}
        content={content}
        tagData={tagData}
        selectedTag={tagArr}
        selectedTagSm={tagCategory}
        handleTagOnChange={handleTags}
        onPublish={onPublish}
        onUploadClick={onUploadClick}
        selectedImage={selectedImage}
        state={articleInstance}
        operationType={operationType}
        resetSelectedImage={resetSelectedImage}
        updateImageField={updateImageField}
        isUploadArticle
        category={CATEGORY_CONTENT}
        subCategory={"article"}
        workflow={workflow}
        // handleClickOpen={handleClickOpen}
        onSave={onSave}
        createComment={createComment}
        isEdit={currentArticleData.current ? true : false}
        publishDisabled={isLoading}
      />
      {dialogContent.isOpen && dialogContent.modal === "publish" ? (
        <CommonPlateformXDialog
          isDialogOpen={dialogContent.isOpen}
          title={dialogContent.title}
          subTitle={dialogContent.subTitle}
          confirmButtonText={dialogContent.confirmButtonText}
          confirmButtonHandle={navigateTo}
          modalType='publish'
        />
      ) : null}
      {dialogContent.isOpen && dialogContent.modal === "warning" ? (
        <CommonPlateformXDialog
          isDialogOpen={dialogContent.isOpen}
          title={dialogContent.title}
          subTitle={dialogContent.subTitle}
          confirmButtonText={dialogContent.confirmButtonText}
          closeButtonText={dialogContent.closeButtonText}
          closeButtonHandle={handleCloseModal}
          confirmButtonHandle={navigateTo}
        />
      ) : null}
    </Box>
  );
};
